import DirectBookingWrapper from './direct-booking-wrapper';
export default DirectBookingWrapper;
